// extracted by mini-css-extract-plugin
export default {"sec-btn":"AddUser_sec-btn__CHqMj"};